import axios from "axios";
import { BASE_URL } from "./type";

export function getMyMeasures() {
    return axios.get(BASE_URL + `measure`);
}

export function getMeasureDatas(page, search = '') {
    let url = BASE_URL + `measure?page=${page}`;
    if (search) {
        url += `&search=${encodeURIComponent(search)}`;
    }
    return axios.get(url);
}

export function getMeasure(id) {
    return axios.get(BASE_URL + `measure/${id}`);
}

export function getBase64Data(filePath) {
    return axios.get(`${BASE_URL}measure/getBase64Image?filePath=${filePath}`);
}

export function getBase64DataArray( id ) {
    return axios.get(`${BASE_URL}measure/getBase64DataArray?id=${ id }`);
}

export function updateMeasure(id, param) {
    const token = localStorage.getItem("token");
    return axios.put(`${BASE_URL}measure/${id}`, {...param}, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
}

export function deleteMeasure(id) {
    return axios.delete(`${BASE_URL}measure/${id}`);
}

export function saveTag(param) {
    return axios.post(`${BASE_URL}dealerTag`, { ...param });
}

export function callNodeAPI(measureId, modelType = 'full') {
  const token = localStorage.getItem("token");
  return axios.get(
    `${BASE_URL}measure/callNodeAPI?id=${measureId}&modelType=${modelType}&generateSegments=true`,
    { 
      withCredentials: false,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }              
  );
}

export function updateUserHeight(userId, heightCm, measureId = null) {
  const token = localStorage.getItem("token");
  const payload = {
    id: userId,
    height: String(heightCm)
  };

  // Add measureId if provided
  if (measureId) {
    payload.measureId = measureId;
  }

  return axios.post(
    `${BASE_URL}user/updateDetails`,
    payload,
    {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );
}

export function getMeasureLogs(params = '') {
  const token = localStorage.getItem("token");
  return axios.get(`${BASE_URL}measure/logs?${params}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
}

export function deleteAllLogs() {
  const token = localStorage.getItem("token");
  return axios.delete(`${BASE_URL}measure/logs`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
}